<pinch-zoom [properties]="pinchZoomProperties">
  <img
    [src]="url()"
    loading="lazy"
    decoding="async"
    alt=""
  />
</pinch-zoom>
